const addNewMetadaToOrderedList = (metadataList, objectType) => {
  const passageName = {
    label: "Passage Name",
    values: [
      "Existing Passage Name (BDU will associate the item with that Passage)",
    ],
  };

  const relatedItemName = {
    label: "Related Item Name",
    values: ["Name of related item"],
  };

  const relatedItemNameForPassage = {
    label: "Related Item Name",
    values: ["Name of related passage"],
  };

  const relationshipDataSource = {
    label: "Relationship Data Source",
    values: ["CDE", "TDSYS", "VITA", "Other"],
  };

  const relationshipType = {
    label: "Relationship Type",
    values: [
      "Enemy",
      "Enemy-Cluing",
      "Enemy-Parallel",
      "Enemy-Identical",
      "Enemy-MIC",
      "Enemy-Revised",
      "Enemy-Reuse",
      "Predecessor",
      "Successor",
      "Parent",
      "Child",
      "Sibling",
      "Parent-Accessible",
      "Child-Accessible",
      "Sibling-Accessible",
      "Parent-Language",
      "Child-Language",
      "Sibling-TEI Item",
      "Sibling-MC Item",
      "Overlap",
      "Parent-MIC",
      "Parent-Reporting",
      "Child-Reporting",
    ],
  };

  let newMetadataItems = [];

  if (objectType === "item") {
    newMetadataItems = [
      passageName,
      relatedItemName,
      relationshipDataSource,
      relationshipType,
    ];
  } else if (objectType === "passage") {
    newMetadataItems = [
      relatedItemNameForPassage,
      relationshipDataSource,
      relationshipType,
    ];
  }

  return metadataList
    .concat(newMetadataItems)
    .sort((a, b) => a.label.localeCompare(b.label));
};

export { addNewMetadaToOrderedList };
